/**
 * 管理系统菜单
 */
export const manageMenusList = [{
        // path: '/productList',
        perm: 'productList',
        label: '产品管理',
        type: 0,
        // icon: 'icon-yonghuguanli',
        imgName: '',
        children: [{
                path: '/productList',
                perm: 'productList',
                type: 2,
                label: '产品列表',
                // icon: 'icon-shangbao',
                imgName: '',
                Comment
            },
            {
                path: '/productCategory',
                perm: 'productCategory',
                type: 3,
                label: '产品类别',
                // icon: 'icon-shangbao',
                imgName: '',
            },
            {
                path: '/productDetail',
                perm: 'productDetail',
                label: '产品详情',
                // icon: 'icon-shangbao',
                imgName: '',
                hidden: true
            }
        ]
    },
    {
        // path: '/orderList',
        perm: 'orderList',
        label: '订单管理',
        type: 1,
        // icon: 'icon-yonghuguanli',
        children: [{
            path: '/orderList',
            perm: 'orderList',
            label: '订单列表'
        }]
    }
]